import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function AtlasMark(props: IconProps) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" {...props}>
      <circle cx="24" cy="24" r="20" {...base} />
      <circle cx="18" cy="24" r="8.5" {...base} />
      <circle cx="30" cy="24" r="8.5" {...base} />
      <path d="M7 31.5c7-3.3 27-3.3 34 0" {...base} />
      <circle cx="24" cy="24" r="2.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><circle cx="10.8" cy="10.8" r="6.8" {...base} /><path d="m16 16 4.3 4.3" {...base} /></svg>;
}

export function SunIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><circle cx="12" cy="12" r="4" {...base} /><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" {...base} /></svg>;
}

export function MoonIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M20.3 15.1A8.5 8.5 0 0 1 8.9 3.7 8.5 8.5 0 1 0 20.3 15Z" {...base} /></svg>;
}

export function MenuIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M4 7h16M4 12h16M4 17h16" {...base} /></svg>;
}

export function CloseIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="m6 6 12 12M18 6 6 18" {...base} /></svg>;
}

export function ArrowIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M5 12h14M14 7l5 5-5 5" {...base} /></svg>;
}

export function ExternalIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M14 5h5v5M19 5l-9 9" {...base} /><path d="M18 13v6H5V6h6" {...base} /></svg>;
}

export function BookIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M4 4.5A3.5 3.5 0 0 1 7.5 8H20v12H7.5A3.5 3.5 0 0 0 4 23.5Z" {...base} transform="translate(0 -2)" /><path d="M4 4.5A3.5 3.5 0 0 1 7.5 8H20" {...base} transform="translate(0 4)" /></svg>;
}

export function FilmIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><rect x="3" y="5" width="18" height="14" rx="1.5" {...base} /><path d="M7 5v14M17 5v14M3 9h4M3 15h4M17 9h4M17 15h4" {...base} /></svg>;
}

export function TypeIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M5 6h14M12 6v13M8 19h8" {...base} /></svg>;
}

export function ExpandIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5" {...base} /></svg>;
}

export function HeadphonesIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M4 14v-2a8 8 0 0 1 16 0v2" {...base} /><path d="M4 14a2 2 0 0 1 2-2h1v7H6a2 2 0 0 1-2-2Zm16 0a2 2 0 0 0-2-2h-1v7h1a2 2 0 0 0 2-2Z" {...base} /></svg>;
}

export function PlayIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="m8 5 11 7-11 7Z" {...base} /></svg>;
}

export function PauseIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M8 5v14M16 5v14" {...base} /></svg>;
}

export function DownloadIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}><path d="M12 3v12m-4-4 4 4 4-4M5 20h14" {...base} /></svg>;
}
